// Developer: Ankit Gupta
/**
 * Orion's mark.
 *
 * Orion answers as AAFAQ, so its mark is the AAFAQ logo itself: the red dotted
 * arc and wordmark from Confy/branding/AAFAQ_Logo_footer.svg, in the brand red
 * on a transparent ground so it sits on a dark or a light surface alike. It is
 * used in the menu, the sidebar and beside every reply. The picture lives in
 * public/brand/aafaq-logo.svg (not under /orion: a folder of that name made the
 * web server refuse the page's own address); a plain red arc of dots is drawn
 * if it cannot be loaded. On a red surface (the current page in the rail, a
 * picked application) theme.css turns it white, as the logo's own white
 * variant, so it never disappears into its background.
 */
import { useState } from 'react';

const BRAND_RED = '#da2d27';

export function OrionIcon({ size = 16, className }: { size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className={className} style={{ flex: 'none' }}>
        <circle cx="16" cy="5" r="2.2" fill={BRAND_RED} />
        <circle cx="8" cy="9" r="2.4" fill={BRAND_RED} />
        <circle cx="5" cy="17" r="2.6" fill={BRAND_RED} />
        <circle cx="8" cy="25" r="2.4" fill={BRAND_RED} />
        <circle cx="16" cy="28" r="2.2" fill={BRAND_RED} />
      </svg>
    );
  }
  // The logo is close to twice as wide as it is tall; squeezed into a square
  // it would draw at half height, so `size` is its height and it takes a
  // little more width than that.
  const width = Math.round(size * 1.6);
  return (
    <img
      src="/brand/aafaq-logo.svg"
      width={width}
      height={size}
      alt=""
      aria-hidden="true"
      className={className ? `dp-aafaq-mark ${className}` : 'dp-aafaq-mark'}
      style={{ width, height: size, objectFit: 'contain', flex: 'none', display: 'inline-block', verticalAlign: 'middle' }}
      onError={() => setFailed(true)}
    />
  );
}

export default OrionIcon;

/**
 * Orion in the menu: the four-point sparkle the theme draws for it. An outline in
 * the current colour, inside an `anticon` span so it takes the size and colour
 * of the rail, panel and button icons beside it.
 */
export function OrionSparkle() {
  return (
    <span role="img" aria-hidden="true" className="anticon">
      <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l2.2 5.8L20 11l-5.8 2.2L12 19l-2.2-5.8L4 11l5.8-2.2z" />
      </svg>
    </span>
  );
}
